// Generated by CoffeeScript 2.7.0
import Admin__UsersController from './users.js';

Skylark.App.Controllers.register({Admin__UsersController});
